import Component from 'vue-class-component';
import moduleStore from './store/videoWechatPay';
import Vue from 'vue';
import PageState from './store/state';
import { Toast } from 'vant';
import LZString from '../../utils/lz-string.min'

/**components**/
@Component({
  components: {},
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class videoWechatPayPage extends Vue implements IvuePage<PageState> {
  state = new PageState();
  self: Vue = this;
  orderInfo = {
    phone: '',
    desc: '',
    price: '',
  };
  selectedType = 0; //0 支付宝 1微信
  unckeckedImg = require('/public/images/sameStyle/radio_uncheck.png');
  checkedImg = require('/public/images/sameStyle/radio_checked.png');
  paramsData = {
    //支付时参数
    phone: '',
    priceActiveId: 6,
    jsCode: '',
  };
  aliPayParams = null;
  packageId:any = null;
  //   let device = isAndroid ? "H5_ANDROID" : "H5_IOS";

  created(moduleData: IinjectDatas) {
    this.state = <PageState>moduleData.state;
  }
  mounted(moduleData: IinjectDatas) {
    document.title = '导出视频';
    this.state.self = this;
    this.packageId = this.$route.params.packageId;
    this.getOrderInfoFn();
  }
  choosePay(type) {
    this.selectedType = type;
  }
  getOrderInfoFn() {
    this.$http('getOrderInfo', { packageId: this.packageId }).then(res => {
      if (res.code == 200) {
        this.orderInfo = res.data.videoTempVO;
        this.orderInfo.phone = res.data.phone;
      } else {
        this.$toast('查询订单信息失败');
      }
    });
  }
  // 购买成功页面路径 -暂时不用
  get successRoute() {
    return {
      path: '/voicePaySuccess',
      query: {
        // price: this.voiceItem.price/100 +'',
        // type: this.voiceItem.type
      },
    };
  }
  /**
   *
   * @returns {boolean} 校验通过true
   */
  phoneCheck() {
    const myreg = /^[1][0-9]{10}$/;
    if (!this.orderInfo.phone) {
      Toast({
        message: '请先输入手机号',
        icon: 'none',
        className: 'phone-toast',
        position: 'top',
      });
      return false;
    }
    if (!myreg.test(this.orderInfo.phone)) {
      Toast({
        message: '请输入正确的手机号',
        icon: 'none',
        position: 'top',
      });
      return false;
    }
    console.log('校验通过');
    return true;
  }
  async preToPay() {
    let rightPhone = await this.phoneCheck();
    if(!rightPhone){
        console.log('手机号校验不通过');
        return;
    }
    let payMethod = this.selectedType===0?'h5Alipay':'wxpayH5';
    let params = {
      packageId: this.packageId, //套餐包id
      phone: this.orderInfo.phone, //手机号
      jsCode: '', //jsCode-微信支付需要
      payMethod: payMethod,
      device: 'H5_IOS',
    };
    this.$http('createOrder', params).then(res => {
      if (res.code == 200) {
        let payParams = res.data.payParams;
        this.h5Pay({ ...payParams });
      } else {
        Toast({
          message: res.message,
          icon: 'none',
          duration: 3000,
          position: 'top',
        });
      }
    });
  }
  h5Pay(payInfo: any, succObj?: any) {
    let infoCompress = LZString.compressToBase64(JSON.stringify({
        ...payInfo,
      }))
      console.log('---hhh5Pay',infoCompress)
    let payType = this.selectedType===0?'alipayH5':'wxpayH5';
    this.$router.push({
      path: '/middlePageOfPay',
      query: {
        info: infoCompress,
        from: 'sameType',
        payType:payType,
        phone: this.orderInfo.phone,
        desc:this.orderInfo.desc
      },
    });
  }
}
